import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { StandAreaMaintenanceTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  StandAreaMaintenanceTypeCreateDto,
  StandAreaMaintenanceTypeDto,
  StandAreaMaintenanceTypeExcelDownloadDto,
  StandAreaMaintenanceTypeUpdateDto,
} from '../proxy/planning/dtos/stand-area-maintenance-type';
import { STANDAREAMAINTENANCETYPE_CONFIG, STANDAREAMAINTENANCETYPE_FIELDS } from './stand-area-maintenance-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-stand-area-maintenance-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, StandAreaMaintenanceTypeService, ConfirmationService],
  templateUrl: './stand-area-maintenance-type.html',
  styleUrl: './stand-area-maintenance-type.scss',
})
export class StandAreaMaintenanceType extends BaseCrudComponent<
  StandAreaMaintenanceTypeDto,
  StandAreaMaintenanceTypeCreateDto,
  StandAreaMaintenanceTypeUpdateDto,
  StandAreaMaintenanceTypeExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(StandAreaMaintenanceTypeService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('StandAreaMaintenanceType', ids),
  };
  config = STANDAREAMAINTENANCETYPE_CONFIG;
  fields = STANDAREAMAINTENANCETYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: StandAreaMaintenanceTypeDto): StandAreaMaintenanceTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'StandAreaMaintenanceType';
  }
}
